import { useMemo } from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { buildSupervisorContragentBlackListValidationSchema } from '~/modules/covenants/CovenantsEmailBlackList/validationSchema.ts';
import { TSupervisorContragentBlackListFormValues } from '~/modules/covenants/CovenantsEmailBlackList/types.ts';

const useSupervisorContragentBlackListForm = () => {
  const validationSchema = useMemo(
    () => buildSupervisorContragentBlackListValidationSchema(),
    []
  );

  return useForm<TSupervisorContragentBlackListFormValues>({
    resolver:
      yupResolver(validationSchema) as unknown as Resolver<TSupervisorContragentBlackListFormValues>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: {
      email: '',
    },
  });
};

export default useSupervisorContragentBlackListForm;
